<div class="sidebar-header">
  @if (!collapsed()) {
    <span class="sidebar-title">{{ 'app.title' | translate }}</span>
  }
</div>

<nav class="sidebar-nav">
  @for (item of navItems; track item.labelKey) {

    @if (hasChildren(item)) {

      @if (!collapsed()) {
        <mat-expansion-panel
          class="nav-expansion"
          [expanded]="isPanelExpanded(item)"
          [class.active-parent]="isParentActive(item)"
          (opened)="onPanelToggled(item.labelKey, true)"
          (closed)="onPanelToggled(item.labelKey, false)"
        >
          <mat-expansion-panel-header>
            <mat-panel-title>
              <dw-icon [icon]="item.icon" [size]="20" />
              <span>{{ item.labelKey | translate }}</span>
            </mat-panel-title>
          </mat-expansion-panel-header>

          @for (child of item.children; track child.route) {
            <a
              class="nav-item nav-child"
              [routerLink]="child.route"
              routerLinkActive="nav-item--active"
              [routerLinkActiveOptions]="{ exact: child.exact ?? false }"
            >
              <dw-icon [icon]="child.icon" [size]="18" />
              <span>{{ child.labelKey | translate }}</span>
            </a>
          }
        </mat-expansion-panel>

      } @else {
        <button
          mat-icon-button
          class="nav-icon-btn"
          [class.nav-icon-btn--active]="isParentActive(item)"
          (click)="onCollapsedParentClick(item)"
          [matTooltip]="item.labelKey | translate"
          matTooltipPosition="right"
        >
          <dw-icon [icon]="item.icon" [size]="20" />
        </button>
      }

    } @else {

      <a
        class="nav-item"
        [routerLink]="item.route"
        routerLinkActive="nav-item--active"
        [routerLinkActiveOptions]="{ exact: item.exact ?? false }"
        [matTooltip]="collapsed() ? (item.labelKey | translate) : ''"
        matTooltipPosition="right"
      >
        <dw-icon [icon]="item.icon" [size]="20" />
        @if (!collapsed()) {
          <span>{{ item.labelKey | translate }}</span>
        }
      </a>

    }
  }
</nav>
